import { ENewbuildingComparison, TNewbuildingComparisonActions } from 'shared/actions/newbuildingComparison';
import { INewbuildingComparisonState } from 'shared/types/newbuildingComparison';

const initialState: INewbuildingComparisonState = {
  comparisonStatus: null,
};

export const newbuildingComparisonReducer = (
  state: INewbuildingComparisonState = initialState,
  action: TNewbuildingComparisonActions,
): INewbuildingComparisonState => {
  switch (action.type) {
    case ENewbuildingComparison.setStatus:
      return {
        ...state,
        comparisonStatus: action.payload,
      };

    default:
      return state;
  }
};
